import React, { useEffect } from 'react'
import LoginFeature from '../../features/LoginFeature'

const Login: React.FC = (): JSX.Element => {
  useEffect(() => {
    localStorage.clear()
  }, [])

  return (
    <>
      <LoginFeature />
    </>
  )
}

export default Login
